import React from 'react'
import newletterbg from "../../assets/img/newletter-bg.png";

const Newsletter = () => {
  return (
    <>
    <section className="tab:py-secpadding py-40">
            <div className="mx-auto 2xl:max-w-screen-xl container text-left sm:px-5 px-2">
              <div
                className="rounded-[20px] lg:py-96 py-10 sm:px-10 px-6 xl:px-[80px] text-white shadow-lg bg-cover"
                style={{ backgroundImage: `url(${newletterbg})` }}
              >
                <div className="flex flex-col lg:flex-row items-center justify-between gap-4 ">
                  {/* Left Section */}
                  <div className="w-full lg:w-auto">
                    <h2 className="text-2xl tab:text-4xl font-semibold text-white md:mb-4 mb-2">
                      Don&apos;t miss out on any updates
                    </h2>
                    <p className="xl:text-lg text-base font-normal text-white">
                      Stay updated on the latest news, exclusive offers, and
                      exciting updates.
                    </p>
                  </div>
    
                  {/* Right Section */}
                  <div className="flex flex-col w-full lg:w-auto gap-4">
                    <div className="flex items-center sm:flex-row flex-col sm:space-x-2 space-x-0 gap-2">
                      <input
                        type="email"
                        placeholder="Enter your email"
                        className="p-3 w-full sm:w-64 rounded-md border border-gray-700 bg-gray-800 text-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <button className="bg-blue hover:bg-blue-100 text-white font-semibold py-3 px-6 rounded-md sm:w-auto w-full">
                        Get access
                      </button>
                    </div>
                    <p className="text-white text-sm text-left font-normal">
                      See our{" "}
                      <a href="#" className="text-sm text-blue hover:underline">
                        Privacy Policy
                      </a>{" "}
                      for data collection details.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
      
    </>
  )
}

export default Newsletter
